angular.module('AccountingBoxApp')
    .controller('InboxProcessedCtrl', function($scope, processed, LoopBackAuth, $state) {
        $scope.message = 'Hello';

        var vm = this;
        vm.apiEndpoint = API_ENDPOINT;
        vm.processed = processed;
        vm.token = LoopBackAuth.accessTokenId;
        vm.toTransaction = function(attachment) {
            var to =attachment.transactionType.toLowerCase()+'s';
            if (attachment.transactionType.toLowerCase() === "journalentry") {
                to = "journalEntries";
            }

            $state.go('app.company.edit.' + to, {
                id: attachment.transactionId
            });
        };
        vm.transactionType = function(attachment) {
            if (attachment.transactionType.toLowerCase() === "sale") {
                return "Verkoopfactuur";
            }
            if (attachment.transactionType.toLowerCase() === "purchase") {
                return "Inkoopfactuur";
            }
              if (attachment.transactionType.toLowerCase() === "journalentry") {
                return "Memoriaal";
            }
        };
        $scope.processed = [{
            'url': 'http://www.adcoservices.com/Invoice.JPG'
        }, {
            'url': 'http://images.vertex42.com/ExcelTemplates/free-invoice.gif'
        }, {
            'url': 'https://www.invoiceberry.com/img/homepage/free_invoice_templates/screenshot_invoiceberry_invoice_template_2.jpg'
        }, {
            'url': 'http://www.solid-innovation.com/images/4inch-Mobile-Invoice.jpg'
        }, {
            'url': 'http://www.solid-innovation.com/images/8x11-Mobile-Invoice.jpg'
        }];
    });
